var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.93 21.86C17.4142 21.86 21.86 17.4142 21.86 11.93C21.86 6.44581 17.4142 2 11.93 2C6.44581 2 2 6.44581 2 11.93C2 17.4142 6.44581 21.86 11.93 21.86Z",
    stroke: "#7A8691",
    strokeWidth: 1.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8999 11.96V17.3",
    stroke: "#7A8691",
    strokeWidth: 1.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9001 8.89984C12.3401 8.89984 12.6801 8.55984 12.6801 8.11984C12.6801 7.67984 12.3401 7.33984 11.9001 7.33984C11.4601 7.33984 11.1201 7.67984 11.1201 8.11984C11.1201 8.55984 11.4601 8.89984 11.9001 8.89984Z",
    stroke: "#7A8691",
    strokeWidth: 1.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.c34d0d4a61e576eb2f39ddcabfcae278.svg";
export { ForwardRef as ReactComponent };